import React from 'react'
import { StyledFormContainer } from './mFormContainer.style'

import {
  Breakpoints,
  Container,
  ContainerPadding,
  ContainerGutter,
  ContainerWrap
} from '@volkswagen-onehub/components-core'

const FormContainer = ({ children }) => (
  <StyledFormContainer>
    <Container
      wrap={{
        [Breakpoints.default]: ContainerWrap.always
      }}
      gutter={{
        [Breakpoints.default]: ContainerGutter.static300,
        [Breakpoints.b560]: ContainerGutter.static300
      }}
      padding={{
        top: {
          [Breakpoints.default]: ContainerPadding.static100,
          [Breakpoints.b560]: ContainerPadding.static300
        }
      }}
    >
      {children}
    </Container>
  </StyledFormContainer>
)

export default FormContainer
